import './RegionSelector.scss'

import {ImageType, PageData} from '../../../types'

import {Dropdown} from '../../ui/Dropdown'
import React from 'react'
import {Theme} from '../../Theme'
import {style} from 'util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('regionselector', ['continent'])

type ContinentSelectorType = PageData & {
	regions: Array<RegionType>
}
export type CountryType = PageData & {
	globe: ImageType
}

type RegionsType = Array<ContinentSelectorType>

export type RegionType = PageData & {
	continent: PageData
}

type RegionSelectorType = {
	regions: Array<RegionType>
	onRegionSelect: (continent: string, region: string) => void
	highlightedContinent: string
	highlightedRegion: string
}

export const RegionSelector: React.FC<RegionSelectorType> = ({
	regions,
	onRegionSelect,
	highlightedRegion,
	highlightedContinent
}) => {
	if (!regions || regions?.length === 0) return null

	const t = useTranslation('impact').projects.regions
	const continents = groupRegionsPerContinent(regions)
	const orderedRegions = orderRegionsForDropdown(continents)

	const regionOnSelectHandler = (item) => {
		let chosenRegion = null
		const chosenContinent = continents.find(
			(continent) => continent.path === item
		)?.path
		const chosenContinentRegion = continents.find((continent) => {
			chosenRegion = continent.regions.find((region) => region.path === item)
				?.path
			return !!chosenRegion
		})?.path
		onRegionSelect(chosenContinent || chosenContinentRegion, chosenRegion)
	}

	const selectedDropdownContinent = orderedRegions?.find(
		(region) => region.path === highlightedContinent
	)
	const selectedDropdownRegion =
		highlightedRegion &&
		orderedRegions?.find((region) => region.path === highlightedRegion)

	return (
		<div className={styles}>
			<div className={styles('container')}>
				<div className={styles('container-dropdown')}>
					<Dropdown
						mod={['border']}
						smallItems
						items={orderedRegions}
						onChange={regionOnSelectHandler}
						selected={
							selectedDropdownRegion || selectedDropdownContinent || null
						}
						defaultText={'-'}
						allowClearSelection
					/>
				</div>
				{(highlightedContinent || highlightedRegion) && (
					<div className={styles('container-link')}>
						<Theme.Link onClick={() => regionOnSelectHandler(null)}>
							{t.select_all}
						</Theme.Link>
					</div>
				)}
			</div>
		</div>
	)
}

const groupRegionsPerContinent = (regions: Array<RegionType>): RegionsType => {
	const continents = regions.reduce((acc, region) => {
		const {continent, ...rest} = region
		const index = acc.findIndex((c) => c.id === continent.id)
		if (index < 0) {
			const newContinent = {
				...continent,
				regions: [{...rest, subCategory: true}]
			}
			acc.push(newContinent)
		} else {
			acc[index].regions.push({...rest, subCategory: true})
		}
		return acc
	}, [])
	return continents
}

const orderRegionsForDropdown = (continents: RegionsType) => {
	let orderedRegions = []
	continents.forEach((continent) => {
		const {regions, ...rest} = continent
		const subcatRegions = regions.map((region) => {
			return {...region, subCategory: true}
		})
		const items = [rest].concat(subcatRegions)
		orderedRegions = [...orderedRegions, ...items]
	})
	return orderedRegions
}
